module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-3d-4e3f72986790436f98a1a7cb5fa44475.svg";